<template>
  <input
    type="checkbox"
    :class="[
      $style.checkbox,
      { [$style['checkbox--checked']]: checked },
      { [$style['checkbox--disabled']]: isDisabled },
    ]"
    :value="value"
    :checked="checked"
    @change="handleChange"
    :disabled="isDisabled"
  />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'DolphinCheckbox',
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object, Date, Function, Symbol],
      default: true,
    },
    modelValue: {
      type: [Boolean, Array] as PropType<boolean | unknown[]>,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const checked = computed((): boolean =>
      Array.isArray(props.modelValue)
        ? props.modelValue.includes(props.value)
        : props.modelValue
    )

    const handleChange = () => {
      if (!Array.isArray(props.modelValue)) {
        emit('update:modelValue', !props.modelValue)
        return
      }
      const newState = checked.value
        ? props.modelValue.filter(value => value !== props.value)
        : [...props.modelValue, props.value]

      emit('update:modelValue', newState)
    }

    return {
      checked,
      handleChange,
    }
  },
})
</script>

<style lang="scss" module>
.checkbox {
  position: relative;
  width: 24px;
  height: 24px;
  appearance: none;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('~@/assets/images/icons/checkbox-off.svg');
    background-size: cover;
    content: '';
  }

  &--checked::before {
    background-image: url('~@/assets/images/icons/checkbox-on.svg');
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &--disabled {
    cursor: not-allowed;
  }

  &--disabled::before {
    background-image: url('~@/assets/images/icons/checkbox-disable.svg');
  }
}
</style>
